import axios from 'axios'
import type { pkgtype,pagination } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'pkgtype'

export const readPkgtypeListAPI = async (pagination: pagination): Promise<pkgtype[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ... pagination
    }
  })
  console.log("readPkgtypeListAPI 응답:", response.data)
  return response.data.data
}

export const addPkgtypeAPI = async (pkgtypename: string): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
      name: pkgtypename
    }
  })
  console.log("addPkgtypeAPI 응답:", response.data)
  return response.data
}

export const updatePkgtypeAPI = async (pkgtype: pkgtype): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...pkgtype
    }
  })
  console.log("updatePkgtypeAPI 응답:", response.data)
  return response.data
}

export const deletePkgtypeAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deletePkgtypeAPI 응답:", response.data)
  return response.data
}

export const paginationPkgtypeAPI = async (size: number) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      size: size,
    }
  })
  console.log("paginationPkgtypeAPI 응답:", response.data)
  return response.data.data.totalpage
}